<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="picker-content">
  <situ-browse
    [allowOpenSituViewOrFacade]="false"
    [allowRenderCancelation]="false"
    [embedded]="true"
    [incomingStyleConfigTemplateId]="data?.styleConfigTemplateId"
    (selectedRenderedOutput)="onPicked($event)">
  </situ-browse>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
